const SeparatorFooter = () => (
  <div className="transition duration-500 h-[50px] md:h-[100px] bg-gray-300 dark:bg-gray-800">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="transition duration-500 fill-gray-200 dark:fill-gray-700 w-[100vw] h-[100%]">
      <path d="M0.00,49.98 C149.99,150.00 271.49,-49.98 500.00,49.98 L500.00,0.00 L0.00,0.00 Z" />
    </svg>
  </div>
);

export default SeparatorFooter;
